<template>
    <v-card
        tile
        flat
        class="balanceCard"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet
                        class="d-flex mb-0"
                        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                    >
                        <div class="title">
                            <v-icon dense color="#5F7692"
                                >mdi-bag-checked</v-icon
                            >
                            <span class="ml-2">My Balance</span>
                            <p class="number mb-0">
                                {{ account_summary?.balance }}
                                <strong>USD</strong>
                            </p>
                        </div>
                        <v-spacer></v-spacer>
                        <p class="mb-0 profit-info">
                            Profit:
                            <strong
                                >{{
                                    account_summary?.totalProfit?.toFixed(2) ||
                                    0
                                }}
                                USD</strong
                            >
                        </p>
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <v-card-text
                        class="d-flex pl-0 pb-2 pr-0 trade align-center"
                    >
                        <p class="equity">
                            Deposit:
                            {{ account_summary?.deposit }} USD
                            <br />Withdraw:
                            {{ account_summary?.withdraw }} USD
                        </p>
                        <v-spacer></v-spacer>
                        <p class="equity text-right">
                            Equity:
                            {{ account_summary?.equity}} USD
                            <br />Bonus:
                            {{ account_summary?.bonus }} USD
                        </p>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    name: "balanceCard",
    components: {},
    data() {
        return {};
    },

    computed: {
        ...mapState("account", ["account_summary"]),
    },

    methods: {
        ...mapActions("account", [PROFILE__ACTIONS.ACCOUNTSUMMARY]),
    },

    async mounted() {
        try {
            await this[PROFILE__ACTIONS.ACCOUNTSUMMARY]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
